import { useCallback, useContext } from 'react'
import styled from 'styled-components'
import { Link as LinkBase } from 'react-router-dom'
import { t } from 'ttag'

import { PG } from '@h2/components/colors'
import { vagRundFont } from '@h2/components/mixins'
import { Globals } from '@h2/globals'

const Link = styled(LinkBase)`
  ${vagRundFont};
  padding: 10px 18px;
  color: ${PG};
  background-color: white;
  border: 2px solid ${PG};
  width: 252px;
  text-align: center;
  border-radius: 5px;
  opacity: 1;
  &:hover {
    color: white;
    background-color: ${PG};
    text-decoration: none;
  }
`
const ReturnToNaviance = () => {
  const { backToNavianceURL } = useContext(Globals)
  const onClickFinished = useCallback(
    evt => {
      evt.preventDefault()
      //This function is invoked only for naviance user. Production redirection url is assigned if there is some error in getting the URL.
      window.location.assign(backToNavianceURL || 'https://student.naviance.com/')
    },
    [backToNavianceURL]
  )

  return (
    <Link
      width="auto"
      variant="button"
      fontSize="20px"
      weight="normal"
      onClick={onClickFinished}>
      {t`Return to Naviance`}
    </Link>
  )
}

export { ReturnToNaviance }
